import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import { PlaceholderPublishButton } from '../src/PlaceholderPublishButton.tsx';
import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';
import type { PublishModalContextProviderExternalProps } from '../src/PublishModalContext.tsx';

export const PublishButtonWithMoreOptions: LoadableType<
	{
		publishButtonDisabled: boolean | undefined;
		userViewingPreview?: boolean;
		isUnpublishedDraft: boolean;
		flags: FlagsStateContainer;
		saveDraft: (() => void) | undefined;
		contentType: string;
		title: string | null;
		savingInProgress: boolean;
		shouldShowWorldIcon: boolean;
		shouldShowFooterButtons?: boolean;
		onHoverPublish?: () => void;
	} & PublishModalContextProviderExternalProps
> = LoadableAfterPaint({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-PublishButtonWithMoreOptions" */ '../src/PublishButtonWithMoreOptions.tsx'
			)
		).PublishButtonWithMoreOptions;
	},
	loading: PlaceholderPublishButton,
});
